import React, {useEffect} from 'react';
import * as S from './style';
import Example from './example-component';
import { useDispatch } from 'react-redux'
import { setSVOnboardingEventParams } from '../../../stores/splashverse-onboarding/actions';
import { isNewCoqAssigned } from '../../../utils/feature_mapping';

const Question = ({
  questionKey, 
  question, 
  positiveShift, 
  responseHandler, 
  playAudio,
  unclickableResponse, 
  questionResponses, 
  currentIndex, 
  questionIndex, 
  questionEventHandler,
  selectedSubject,
  childScreenName
}) => {

  const dispatch = useDispatch();

  // Sorting options according to ordering for Variant users only
  const sortedOptions = isNewCoqAssigned() ? question.options.slice().sort((val1, val2) => val1?.ordering - val2?.ordering) : question.options;
    
  const getOptionsText = () => question ? sortedOptions.map((val)=>val.text) : [];

  useEffect(() => {
    if(currentIndex === questionIndex) {
      const options = getOptionsText();
      dispatch(setSVOnboardingEventParams({
        params: {
          "Question Index": questionIndex + 1, 
          "Options": options
        },
        interactedFrom: 'Onboarding Question Interacted'
      }));
      questionEventHandler({'Question Index': questionIndex+1, viewed: true, question: question});
    }
  },[currentIndex])
  return (
    <S.Question>
      <p>{question.text.replace("<c_name>", childScreenName)}</p>
      {question.illustration_type &&  <S.ExampleWrapper id={`question_img_${questionKey}`} className='animate-example' positiveShift={positiveShift}>
        <span>e.g.</span>
        <Example question={question} questionKey={questionKey} playAudio={playAudio} selectedSubject={selectedSubject}/>
      </S.ExampleWrapper>}
      <S.ResponseWrapper className='response-wrapper' positiveShift={true} currentIndex={currentIndex}>
        {
          sortedOptions.map((option) => {
            let isFilled = questionResponses && questionResponses[questionKey] === option.id
            return <S.Response filled={isFilled} onClick={(e) => unclickableResponse ? null : responseHandler(e, option.id, question, questionKey)}>{option.text}</S.Response>
          })
        }
      </S.ResponseWrapper>
    </S.Question>
  )
}

export default Question;